"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FrequentlyAskedQuestions() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const faqs = [{
    id: 1,
    question: "How quickly can I receive a cash offer for my house?",
    answer: "Typically, we can provide you with a no-obligation cash offer within 24-48 hours of your initial inquiry. Our team evaluates your property quickly and presents a transparent, fair offer."
  }, {
    id: 2,
    question: "Are there any fees or hidden costs involved?",
    answer: "No. CashHome covers all title fees, closing fees, and transfer fees. You receive the full agreed-upon amount with no out-of-pocket expenses or surprise deductions."
  }, {
    id: 3,
    question: "What types of properties does CashHome purchase?",
    answer: "We purchase homes in any condition—whether move-in ready or needing major repairs. Our nationwide service covers single-family homes, townhouses, and condos across the country."
  }, {
    id: 4,
    question: "How long does the closing process take?",
    answer: "Once you accept our offer, we can close in as little as 7-14 days, depending on your timeline. We work around your schedule to ensure a smooth, hassle-free transaction."
  }, {
    id: 5,
    question: "Do I need to make any repairs before selling?",
    answer: "Absolutely not. We buy houses as-is, so you don't need to invest time or money in repairs, renovations, or even cleaning. We handle everything."
  }, {
    id: 6,
    question: "Is CashHome available in my area?",
    answer: "Yes! CashHome operates nationwide, providing fast cash offers and covering all associated fees no matter where your property is located."
  }];
  return <section id="frequently-asked-questions" ref={sectionRef} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg">
            Find answers to common questions about our cash-for-houses service.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => {
          const {
            ref: itemRef,
            isVisible: itemVisible
          } = useRevealOnScroll({
            threshold: 0.3,
            once: true
          });
          return <div key={faq.id} data-index={i} ref={itemRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${itemVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <AccordionItem value={`item-${faq.id}`} className="border-border">
                  <AccordionTrigger className="text-foreground hover:text-primary text-base sm:text-lg font-semibold py-5 transition-colors duration-[var(--duration-fast)]">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </div>;
        })}
        </Accordion>
      </div>
    </section>;
}